<template>
  <mp-flex v-if="contributors.length" flex-direction="column">
    <mp-flex
      v-for="user in contributors"
      :key="user.id"
      align-items="center"
      p="2"
      border-bottom-color="gray.100"
      :border-bottom-width="contributors.length > 1 ? 'sm' : 0"
      gap="3"
    >
      <mp-avatar :src="user.avatar" w="36px" h="36px" />
      <mp-box>
        <mp-text>{{ user.name }}</mp-text>
        <mp-text font-size="sm" color="gray.600"> {{ user.id_employee }} | {{ user.organization_name }} | {{ user.job_position_name }} </mp-text>
      </mp-box>
    </mp-flex>
  </mp-flex>
</template>

<script>
export default {
  name: 'ContributorListView',
  props: {
    contributors: {
      type: Array,
      required: true,
    },
  },
};
</script>
